import axios from 'axios'

export function uploadSpaceImage(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function createSpace(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getSpaces() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces?sort=-created_at&page[size]=80', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function deleteSpace(spaceId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function updateSpace(spaceId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSpace(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSpaceByURL(spaceURL) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/-actions/space-info?subdomain=' + spaceURL, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSpaceByURLWithoutToken(spaceURL) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/-actions/get-info?subdomain=' + spaceURL, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSpaceUsers(spaceId, page, size, startDate, endDate) {
    let filter_params = ''
    if(startDate){
        filter_params = '&filter[login-start-date]='+startDate
    }
    if(endDate){
        filter_params = filter_params + '&filter[login-end-date]='+endDate
    }
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?filter[participants]=1&page[size]=' + size + '&page[number]=' + page + filter_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function searchSpaceUsersActivity(spaceId, activityId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?filter[for-activity]=' + activityId + '&page[size]=500&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function searchSpaceUsers(spaceId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=500&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchSpaceBoostersActivityExcluded(spaceId, activityId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=500&filter[boosters-excluded-from-activity]=' + activityId + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function searchSpaceBoostersTargetGroupExcluded(spaceId, tgId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=500&filter[boosters-excluded-from-target-group]=' + tgId + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
//endpoint that exclude users which are already added in the group.
export function getUsersNotAddedToTargetGroup(spaceId, tgId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?filter[excluded]=' + tgId + '&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getSpaceInviteUsers(spaceId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-invitations?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getSpaceGuests(spaceId, page, size, startDate, endDate) {
    let filter_params = ''
    if(startDate){
        filter_params = '&filter[login-start-date]='+startDate
    }
    if(endDate){
        filter_params = filter_params + '&filter[login-end-date]='+endDate
    }
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?filter[guests]=1?page[size]=' + size + '&page[number]=' + page + filter_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function checkEmailExist(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/invitations/-actions/check-email', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function invitePeople(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/invite', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function resendInvite(inviteId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/invitations/' + inviteId + '/-actions/resend-invite', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function joinSpaceCheckUserExists(signature) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/invitations/-actions/check-user-existence?signature=' + signature, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function joinSpaceRegisterUser(signature, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users?signature=' + signature, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function joinSpace(signature) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/-actions/join?signature=' + signature + '&role=participant', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function cancelInvite(inviteId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/invitations/' + inviteId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    })
}
export function promoteGuestToSpaceMember(spaceId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/promote-guest-to-member', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function removeSpaceMember(spaceId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/remove-member', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function removeSpaceMembers(spaceId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/remove-members', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getPersonalAccessTokens(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/personal-access-tokens', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function generateAccessToken(spaceId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/personal-access-token', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function addSAMLConfiguration(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/idps', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function editSAMLConfiguration(idpId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/idps/' + idpId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getSAMLConfiguration(idpId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/idps/' + idpId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function updateRole(inviteId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/invitations/' + inviteId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
//Change the role of a user, on space 
export function updateRoleSpaceMember(spaceId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/change-user-role', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function checkSpace(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/-actions/check-availability', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function downgradeToFreePlan(spaceId) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/switch-to-free-plan', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}
//It fetches the active plan of the space
export function getSubscribedPlan(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/product', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
//This will fetch the pro plan if user is currently on a lower plan
export function getProPlan(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/products/-actions/upgrade-options?space=' + spaceId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
//Get data for invites, allowed and current space members for each role
export function getSpaceUsersStatistics(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users-statistics', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getRecalculatedStorage(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/recalculate-storage', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function checkoutProMonthly(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/checkout-pro-monthly', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function checkoutProYearly(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/checkout-pro-yearly', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getStripePortal(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/stripe-portal', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getSpaceAdmins(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?filter[admins]=1', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function changeSpaceOwner(spaceId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/change-space-owner', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function getSpaceBoosters(spaceId, page, size, startDate, endDate) {
    let filter_params = ''
    if(startDate){
        filter_params = '&filter[login-start-date]='+startDate
    }
    if(endDate){
        filter_params = filter_params + '&filter[login-end-date]='+endDate
    }
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?filter[boosters]=1&page[size]=' + size + '&page[number]=' + page + filter_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchInSpaceUsers(spaceId, searchTerm, page, size, startDate, endDate) {
    searchTerm = encodeURIComponent(searchTerm)
    let filter_params = ''
    if(startDate){
        filter_params = '&filter[login-start-date]='+startDate
    }
    if(endDate){
        filter_params = filter_params + '&filter[login-end-date]='+endDate
    }
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm + '&filter[include-me]=1&filter[participants]=1' + filter_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchInSpaceBoosters(spaceId, searchTerm, page, size, startDate, endDate) {
    searchTerm = encodeURIComponent(searchTerm)
    let filter_params = ''
    if(startDate){
        filter_params = '&filter[login-start-date]='+startDate
    }
    if(endDate){
        filter_params = filter_params + '&filter[login-end-date]='+endDate
    }
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm + '&filter[include-me]=1&filter[boosters]=1' + filter_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchInSpaceGuests(spaceId, searchTerm, page, size, startDate, endDate) {
    searchTerm = encodeURIComponent(searchTerm)
    let filter_params = ''
    if(startDate){
        filter_params = '&filter[login-start-date]='+startDate
    }
    if(endDate){
        filter_params = filter_params + '&filter[login-end-date]='+endDate
    }
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm + '&filter[include-me]=1&filter[guests]=1' + filter_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchInSpaceInviteUsers(spaceId, searchTerm, page, size) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/invitations?page[size]=' + size + '&page[number]=' + page + '&filter[keyword]=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getIntegrations(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/integrations', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function saveIntegration(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateIntegration(integrationId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function syncIntegrationUsers(integrationId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/sync-employees', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getIntegrationUsers(integrationId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/check-employees?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function saveEduAdminIntegration(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/eduadmins', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateEduAdminIntegration(integrationId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/eduadmins/' + integrationId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function searchGlobal(spaceId, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/search?keyword=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSharedTemplates(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/shared-activity-templates', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}


export function getEmailTemplates() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/email-templates', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getEmailCustomizations(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/email-customizations', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createEmailCustomization(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/email-customizations', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateEmailCustomization(emailCustomizationId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/email-customizations/' + emailCustomizationId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function deleteEmailCustomization(emailCustomizationId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/email-customizations/' + emailCustomizationId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    })
}
